import { FCX } from "@datassential/platform-ui-lib";
import LineEllipsis from "@components/LinesEllipsis/LinesEllipsis";

export const MenuItemNameCell: FCX<{ value?: string | null }> = ({ value }) => (
    <LineEllipsis lines={3}>
        {(value ?? '').toUpperCase()}
    </LineEllipsis>
);

export const DescriptionCell: FCX<{ value?: string | null }> = ({ value }) => (
    <div className="MenuExamplesPopup__text">
        {value && (
            <LineEllipsis lines={3}>
                {value}
            </LineEllipsis>
        )}
    </div>
);

export const PriceCell: FCX<{ price?: string | null; currencySymbol: string }> = ({ price, currencySymbol }) => (
    <>
        <span className="MenuExamplesPopup__currency">
            {price && price !== "-" ? currencySymbol : null}
        </span>
        {price}
    </>
);

export const VenueCell: FCX<{ value?: string | null }> = ({ value }) => (
    <>
        {(value ?? '').toUpperCase()}
    </>
);
